import { Divider, Paper, Tab, Tabs } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import CustomDataGridFilterToolbar from "../../../common/js/components/CustomDataGridFilterToolbar";
import DataAdminDealsGrid from "./DataAdminDealsGrid";

const StyledPageToolbar = styled("div")({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    marginBottom: "20px",
    marginTop: "20px",
});

const StyledTabs = styled(Tabs)({
    borderBottom: "none",
    marginRight: "20px",
    position: "absolute",
    bottom: 0,
    width: "30em",
});

const StyledTab = styled(Tab)({
    borderBottom: "none",
    marginRight: "20px",
});

const StyledPaperSpacing = styled(Paper)({
    padding: "10px 20px",
    fontSize: 14,
    marginBottom: "15px",
});

const StyledDivider = styled(Divider)({
    backgroundColor: "rgba(0, 0, 0, 0.06)",
    margin: "0 -20px 0 -20px",
});

const StyledPaperContainer = styled("div")({
    display: "flex",
    justifyContent: "space-between",
});

const StyledFilter = styled("div")({
    padding: "8px",
});

const StyledTabsContainer = styled("div")({
    position: "relative",
    padding: "8px",
});

const DataAdminDeals = (props) => {
    const { deals, dealView, getDataAdminDeals, setDealsFilter, setDealsPage } = props;

    const dataAdminDeals = deals[dealView];

    const filterColumns = [
        { field: "dealName", label: "Deal Name", type: "plaintext" },
        { field: "addressLine", label: "Address Line", type: "plaintext" },
        { field: "city", label: "City", type: "plaintext" },
        { field: "state", label: "State", type: "plaintext" },
        { field: "zipCode", label: "ZipCode", type: "plaintext" },
        { field: "brokers", label: "Broker", type: "plaintext" },
        { field: "totalCommission", label: "Total Commission", type: "currency" },
        { field: "totalKmCommission", label: "Total KM Commission", type: "currency" },
        { field: "paymentAttachedDate", label: "Payment Attached Date", type: "date" },
    ];

    return (
        <React.Fragment>
            <StyledPageToolbar>
                <h2 className="page-title">Deals</h2>
            </StyledPageToolbar>

            <StyledPaperSpacing>
                <StyledPaperContainer>
                    <StyledTabsContainer>
                        <StyledTabs value={dealView} indicatorColor="primary">
                            <StyledTab value="data_admin_needs_final_review" label="Needs Final Review" />
                        </StyledTabs>
                    </StyledTabsContainer>
                    <StyledFilter>
                        <CustomDataGridFilterToolbar
                            key={dealView}
                            fields={filterColumns}
                            setFilter={setDealsFilter}
                            setPage={setDealsPage}
                            onSubmit={getDataAdminDeals}
                        />
                    </StyledFilter>
                </StyledPaperContainer>
                <StyledDivider />
                <DataAdminDealsGrid key={dealView} dataAdminDeals={dataAdminDeals} {...props}></DataAdminDealsGrid>
            </StyledPaperSpacing>
        </React.Fragment>
    );
};

export default DataAdminDeals;
